export default "__VITE_ASSET__12c1c6ef__"